import Vue from "vue";
import Vuex from "vuex";
import state from './state'
import mutations from './mutations'

Vue.use(Vuex);
export default new Vuex.Store({
    state,
    mutations,
    actions: {},
    getters: {
      sessaoAgendamento(state){
        return state.sessaoAgendamento;
      },
      autenticacaoMicrovixAgendamentoOnline(state){
        return state.autenticacaoMicrovixAgendamentoOnline;
      },
      autenticacaoMicrovixAgenda(state){
        return state.autenticacaoMicrovixAgenda;
      },
      sessaoAgendamentoOnline(state){
        return state.sessaoAgendamentoOnline;
      },
    },
});
